module.exports = __webpack_public_path__ + "img/bptlbarmarkerred.138b1dab.svg";